/*
import PaginatedList from '@theme/paginated-list';
export default class BlogPostsList extends PaginatedList {}
if (!customElements.get('blog-posts-list')) {
  customElements.define('blog-posts-list', BlogPostsList);
}
*/

class BlogPostsList extends HTMLElement {
  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    this.sectionId   = this.getAttribute('section-id') || '';
    this.grid        = this.querySelector('[ref="grid"]');
    this.button      = this.querySelector('[ref="seeAll"]');
    this.currentPage = parseInt(this.grid?.dataset.currentPage || '1', 10);
    this.lastPage    = parseInt(this.grid?.dataset.lastPage || '1', 10);
    this.loading     = false;

    if (!this.sectionId || !this.grid || !this.button) return;
    if (this.currentPage >= this.lastPage) {
      this.button.style.display = 'none';
      return;
    }

    this.button.addEventListener('click', () => {
      this.button.style.display = 'none';
      this.startInfiniteLoading();
      this.loadNextPage();
    });
  }

  startInfiniteLoading() {
    this.observer = new IntersectionObserver(() => {
      const scrollBottom = window.innerHeight + window.scrollY;
      const threshold = this.grid.offsetTop + this.grid.offsetHeight - 400;
      if (scrollBottom >= threshold) this.loadNextPage();
    });
    this.observer.observe(this.grid);
  }

  async loadNextPage() {
    if (this.loading) return;
    if (this.currentPage >= this.lastPage) return this.endInfiniteLoading();

    this.loading = true;

    try {
      const page = this.currentPage + 1;
      const html = await this.fetchSectionPage(page);
      this.appendCardsFromHTML(html);
      this.currentPage = page;

      if (this.currentPage >= this.lastPage) this.endInfiniteLoading();
    } catch (e) {
      console.error(e);
    } finally {
      this.loading = false;
    }
  }

  endInfiniteLoading() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
    if (this.button) this.button.style.display = 'none';
  }

  async fetchSectionPage(page) {
    const url = new URL(window.location.href);
    url.searchParams.set('page', String(page));
    url.searchParams.set('sections', this.sectionId);

    const res = await fetch(url.toString(), {
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json'
      },
      cache: 'no-store'
    });
    if (!res.ok) throw new Error(`Failed to load page ${page}`);
    const data = await res.json();
    return data[this.sectionId] || '';
  }

  appendCardsFromHTML(sectionHTML) {
    if (!sectionHTML) return;
    const doc = new DOMParser().parseFromString(sectionHTML, 'text/html');
    const newCards = doc.querySelectorAll('[ref="cards[]"]');
    if (!newCards.length) return;

    const frag = document.createDocumentFragment();
    newCards.forEach((card) => {
      frag.appendChild(document.importNode(card, true));
    });
    this.grid.appendChild(frag);
  }
}

customElements.define('blog-posts-list', BlogPostsList);